import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=0b2d06b2&scoped=true&"
import script from "./Organizations.vue?vue&type=script&lang=ts&"
export * from "./Organizations.vue?vue&type=script&lang=ts&"
import style0 from "./Organizations.vue?vue&type=style&index=0&id=0b2d06b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d06b2",
  null
  
)

export default component.exports